// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import { BPagination, BProgress, BTable } from 'bootstrap-vue/dist/bootstrap-vue.esm.min'
import ToggleButton from 'vue-js-toggle-button'
import App from './App'
import router from './router'
import store from './store'

Vue.use(ToggleButton)

Vue.component('b-pagination', BPagination)
Vue.component('b-progress', BProgress)
Vue.component('b-table', BTable)

sync(store, router)

Vue.config.productionTip = false

// Disable warning about using .native on <a> tags
Vue.config.warnHandler = function (msg) {
  if (msg !== 'The .native modifier for v-on is only valid on components but it was used on <a>.') {
    console.error(msg)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js